import React, { useState } from 'react'
import { Container, Typography, Grid2, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form';
import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import CustomButton from '@components/button/customButton'
import ControlledTextField from '@components/inputs/controlledTextField'
import ConfirmDialog from '@components/dialog/confirmDialog'
import InfoDialog from '@components/dialog/infoDialog';

import { useSnackbar } from '@context/snackbarContext'

import { UserApiEndpoints } from '@configuration/apiEndpoints'

import "./unsubscribe.css";

export default function Unsubscribe() {
  const { t } = useTranslation()
  const openSnackbar = useSnackbar();

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)

  const [infoDialogConfig, setInfoDialogConfig] = useState({
    open: false,
    dialogTitle: t('unsubscribe-page.unsubscribeSuccess'),
    dialogDescription: t('unsubscribe-page.unsubscribeSuccessDesc')
  })

  const { handleSubmit, control, getValues, reset, } = useForm({})

  const unsubscribeMutation = useMutation({
    mutationFn: (data) => {
      return axios.delete(`${UserApiEndpoints.unsubscribeNewsletter}/${data}`,  { requiresAuth: false })
    },
    onSuccess: (res) => {
      reset()
      setOpenConfirmDialog(false)
      setInfoDialogConfig({
        open: true,
        dialogTitle: t('unsubscribe-page.unsubscribeSuccess'),
        dialogDescription: t('unsubscribe-page.unsubscribeSuccessDesc')
      })
    },
    onError: (err) => {
      setOpenConfirmDialog(false)
      if(err?.response?.data === "Record not found"){
        setInfoDialogConfig({
          open: true,
          dialogTitle: t('unsubscribe-page.emailNotFound'),
          dialogDescription: t('unsubscribe-page.emailNotFoundDesc')
        })
      }
      else {
        openSnackbar(t('unsubscribe-page.unsubscribeFailed'), "error");
      }
      // if (err?.response) openSnackbar(err?.response?.data, "error");
      // else openSnackbar("Unable to submit payment", "error");
    }
  })

  const onSubmit = () => {
    setOpenConfirmDialog(true)
  };

  const onConfirmSubmit = () => {
    const data = getValues()
    unsubscribeMutation.mutate(data?.emailAddress)
  }


  
  return (
    <Container className='payment' maxWidth="md">
      <Typography className='title'>{t('unsubscribe-page.unsubscribe')}</Typography>
      <Typography className='description'>{t('unsubscribe-page.unsubscribeDesc')}</Typography>

      <form onSubmit={handleSubmit(onSubmit)} className='content-wrapper'>
        <Paper className='content-card'>
          <Grid2 container spacing={'25px'}>
            <Typography className='content-title'>{t('unsubscribe-page.enterYourEmail')}</Typography>
            <Grid2 size={12}>
              <ControlledTextField 
                name="emailAddress"
                control={control}
                label={t('register-page.emailAddress')}
                variant='standard'
                size='medium'
                rules={{
                  required: t('register-page.emailAddressRequired'),
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: t('register-page.emailAddressInvalid'),
                  }
                }}
                // disabled={fetchFundMutation.isPending || fetchFundMutation.isError}
              />
            </Grid2>
          </Grid2>
        </Paper>
        <Paper className='content-card'>
          <CustomButton type="submit" loading={unsubscribeMutation.isPending}>{t('confirm')}</CustomButton>
        </Paper>
      </form>
      <ConfirmDialog 
        open={openConfirmDialog}
        onClose={()=>setOpenConfirmDialog(false)}
        onSubmit={onConfirmSubmit}
        dialogTitle={t('unsubscribe-page.unsubscribeNewsletter')}
        dialogDescription={t('unsubscribe-page.unsubscribeNewsletterConfirmation')}
        cancelText={t('cancel')}
        confirmText={t('confirm')}
        loading={unsubscribeMutation.isPending}
      />
      <InfoDialog 
        open={infoDialogConfig.open}
        onClose={()=>setInfoDialogConfig(prev => ({...prev, open: false}))}
        dialogTitle={infoDialogConfig.dialogTitle}
        dialogDescription={infoDialogConfig.dialogDescription}
        closeText={t('ok')}
      />
    </Container>
  )
}
